import { Template } from "./template.js";


const Page0_login = {
	template: Template,
	data: function() {
		return {}
	},
	mounted() {
		this.$clearLogin();
	}

}

export { Page0_login }


// WEBPACK FOOTER //
// ./src/app/js/components/page0_login/component.js